<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{suspensionPrintModel.suspensionId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{suspensionPrintModel.suspensionId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{suspensionPrintModel.enterpriseName}}</p>
                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{suspensionPrintModel.branchName}}</p>
                  <!--Nombre Suspension -->
                  <p id="nombre-suspension-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'SUSPENSION Nro.'+ suspensionPrintModel.consecutive}}</p>
                  <!--Dirección  -->
                  <label id="t-direccion-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{suspensionPrintModel.branchAddress}}</p>
                  <!--Teléfono  -->
                  <label id="t-telefono-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' | formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{suspensionPrintModel.branchPhone}}</p>
                  <!-- Fecha Suspension -->
                  <label id="t-fecha-suspension-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha-suspension' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-suspension-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{suspensionPrintModel.dateSuspension | date: 'dd/MM/yyyy'}}</p>
                  <!--C.Costos  -->
                  <label id="t-centro-costos-{{suspensionPrintModel.suspensionId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-centro-costos' | formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="centro-costos-{{suspensionPrintModel.suspensionId}}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{suspensionPrintModel.costCenter}}
                  </p>
                  <!-- Dirección -->
                  <label id="t-direccion-obra-{{suspensionPrintModel.suspensionId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-direccion-obra' | formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="direccion-obra-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{suspensionPrintModel.constructionSiteAddress}}</p>
                  <!--Teléfono  -->
                  <label id="t-telefono-obra-{{suspensionPrintModel.suspensionId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono-obra' | formatLabelPipe
                    : elementsLabel}}</label>
                  <p id="telefono-obra-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{suspensionPrintModel.constructionSitePhone}}</p>
                  <!--Cliente  -->
                  <label id="t-cliente-{{suspensionPrintModel.suspensionId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{suspensionPrintModel.constructionSiteClient}}</p>
                  <!--Estado  -->
                  <label id="t-estado-{{suspensionPrintModel.suspensionId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-estado' | formatLabelPipe : elementsLabel}}</label>
                  <p id="estado-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{suspensionPrintModel.suspensionState}}</p>

                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-suspension-{{suspensionPrintModel.suspensionId}}"
                  [columns]="columns" [data]="suspensionPrintModel.suspensionDetails" [idMap]="idMap"
                  [documentId]="suspensionPrintModel.suspensionId" [footerVisible]="false" [editFormat]="editFormat"
                  (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <!-- Observaciones -->
              <div id="foot-{{suspensionPrintModel.suspensionId}}" class="foot mt-1 container-observations">
                <label id="t-observación-suspension-{{suspensionPrintModel.suspensionId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="suspensionPrintModel.observation">{{'t-observación-suspension' |
                  formatLabelPipe : elementsLabel}}</label>
                <p id="observación-suspension-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()" *ngIf="suspensionPrintModel.observation">
                  {{suspensionPrintModel.observation}}
                </p>
                <!-- Firma Diligencia-->
                <p id="linea-firma-diligencia-{{suspensionPrintModel.suspensionId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-diligencia-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-linea-diligencia' | formatLabelPipe : elementsLabel}}</label>
                <!-- Firma Autoriza-->
                <p id="linea-firma-autoriza-{{suspensionPrintModel.suspensionId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-autoriza-{{suspensionPrintModel.suspensionId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-linea-autoriza' | formatLabelPipe : elementsLabel}}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{suspensionPrintModel.userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>